module.exports = __webpack_public_path__ + "static/media/Logo.11474afa.png";